import { actionTextColor } from "../../utils/themeContrast";
import { IoCheckmarkOutline } from "react-icons/io5";
import { lightTint, readableText } from "../../utils/themeContrast";
import React, { useEffect, useRef } from "react";
import styled from "@emotion/styled";
import { UserContext, ThemeContext } from "../../contexts/Context";
import { getMenuAvailabilityInfo } from "../../utils/menuAvailability";

const ItemSize5 = ({
  lanIndex,
  isLanReverse,
  item,
  handleOnClick,
  active,
  isSetMeal,
  selectedItems,
  currencySymbol,
  addItemDirect,
  cp,
  addQty,
  theme,
  minusQty,
  shouldHide,
  optionType,
  cardLayout = false
}) => {
  //when user click item
  const themeContext = React.useContext(ThemeContext);
  const { displayNetAmount, tax, hideLimitedTimeInfo, hidePrice } = React.useContext(UserContext);
  const ref = useRef(null);
  const availabilityInfo = hideLimitedTimeInfo ? null : getMenuAvailabilityInfo(item);

  useEffect(() => {
    if (!shouldHide) return;
    if (!ref || ref == null) return;
    if (ref.current == null) return;
    if (ref.current.getBoundingClientRect().top < window.innerHeight) {
      ref.current.style.backgroundImage = `url('${ref.current.dataset.bg}')`;
      ref.current.classList.remove('item-img');
    }

  }, [ref]);
  return (
    <React.Fragment>
      <ItemWrapper themeContext={themeContext}
        cardLayout={cardLayout}
        role="button"
        tabIndex={item.isSoldOut ? -1 : 0}
        aria-pressed={Boolean(active)}
        aria-disabled={Boolean(item.isSoldOut)}
        onKeyDown={(event) => {
          if (!item.isSoldOut && (event.key === "Enter" || event.key === " ")) {
            event.preventDefault();
            handleOnClick();
          }
        }}
        active={active}
        onClick={(e) => {
          e.stopPropagation();
          if (!item.isSoldOut) {
            handleOnClick();
          }
        }}
      >
        {item.image &&
          <ItemDisplay
            cardLayout={cardLayout}
            ref={ref}
            key={item.image.codeId}
            className="item-img"
            data-bg={item.image}
            shouldHide={shouldHide}
            enlarge={cp == 1}
          />
        }
        <ItemTitleWrapper cardLayout={cardLayout} themeContext={themeContext} size={item.size} cp={cp}>
          <ItemTitle themeContext={themeContext} title={item.title} theme={theme} enlarge={cp == 1}>
            {(lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ?
              (item.isCategory ? item.category : item.title) :
              (item.isCategory ? (item.category2 || item.category) : (item.title2 || item.title))
            }
          </ItemTitle>


          {!hidePrice && item.price > 0 &&
            <PriceDisplay themeContext={themeContext} enlarge={cp == 1}>
              {optionType == 6 || isSetMeal ? "+" : ""} {`${currencySymbol} ${(displayNetAmount ? (item.price * (1 + (tax.taxMode == 0 ? tax.tax : item.tax))) : item.price).toFixed(2)}`}
            </PriceDisplay>
          }

          <ItemPlainDescription size={item.size} themeContext={themeContext}>
            {(lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ?
              item.description :
              (item.description2 ? item.description2 : item.description)
            }
          </ItemPlainDescription>
          {availabilityInfo &&
            <ItemAvailabilityBadge isUnavailable={availabilityInfo.isUnavailable}>
              {availabilityInfo.text}
            </ItemAvailabilityBadge>
          }
          {Array.isArray(item.icons) && item.icons.length > 0 &&
            <IconHolder icons={item.icons} enlarge={cp == 1} />
          }
        </ItemTitleWrapper>

        <SelectionIndicator themeContext={themeContext} active={active} cardLayout={cardLayout} aria-hidden="true">
          {active && <IoCheckmarkOutline size={15} />}
        </SelectionIndicator>
        {item.isSoldOut &&
          <SoldOut src="/soldout.png" />
        }

      </ItemWrapper>
    </React.Fragment>
  );
};

export default ItemSize5;

const ItemWrapper = styled.div`
  display: flex;
  flex-direction: ${props => props.cardLayout ? "column" : "row"};
  align-items: ${props => props.cardLayout ? "stretch" : "center"};
  gap: ${props => props.cardLayout ? 0 : 12}px;
  height: ${props => props.cardLayout ? "100%" : "auto"};
  min-height: ${props => props.cardLayout ? 0 : 88}px;
  box-sizing: border-box;
  padding: ${props => props.cardLayout ? "0" : "10px 12px"};
  margin: ${props => props.cardLayout ? "0" : "8px 16px"};
  border: 1px solid ${props => props.active ? props.themeContext.primaryColor : (props.themeContext.borderColor || "#e4e4e4")};
  border-radius: 14px;
  background: ${props => props.active ? lightTint(props.themeContext.primaryColor, 0.06) : props.themeContext.backgroundColor};
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.04);
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: border-color 160ms ease, background-color 160ms ease;
  &:focus-visible { outline: 2px solid ${props => props.themeContext.primaryColor}; outline-offset: 2px; }
`;
const ItemTitleWrapper = styled.div`
  flex: 1;
  min-width: 0;
  padding: ${props => props.cardLayout ? "12px" : "0"};
  text-align: left;
`;
const ItemTitle = styled.div`
  display: -webkit-box;
  font-family: ${props => props.themeContext.fontFamily};
  font-size: 14px;
  font-weight: 500;
  line-height: 1.4;
  color: ${props => readableText(props.themeContext.backgroundColor, props.themeContext.fontPrimary)};
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  overflow-wrap: anywhere;
`;
const SelectionIndicator = styled.span`
  display: flex;
  flex: 0 0 22px;
  width: 22px;
  height: 22px;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  border-radius: 50%;
  border: 1px solid ${props => props.active ? props.themeContext.primaryColor : lightTint(props.themeContext.primaryColor, 0.35)};
  background: ${props => props.active ? props.themeContext.primaryColor : props.themeContext.backgroundColor};
  color: ${props => actionTextColor(props.themeContext)};
  ${props => props.cardLayout && "position: absolute; top: 10px; right: 10px;"}
`;

const SoldOut = styled.img`
  width: 50%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;
const PriceDisplay = styled.div`
  color: ${(props) => props.themeContext.primaryColor};
  font-weight: 500;
  font-size: ${(props) => props.enlarge ? "16px" : "14px"};
  margin-top: 4px;
`;

const ItemPlainWrapper = styled.div`

`;

const ItemPlainDescription = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 2;
  text-align: left;
  overflow: hidden;
  -webkit-box-orient: vertical;
  font-size: 12px;
  padding: 0;
  color: ${(props) => props.themeContext.fontPrimary};
  font-weight: 400;
  line-height: 1.4;
  &:not(:empty) { margin-top: 4px; }
`;

const ItemAvailabilityBadge = styled.div`
  display: inline-block;
  max-width: calc(100% - 16px);
  margin-left: 8px;
  margin-bottom: 8px;
  padding: 3px 6px;
  border-radius: 4px;
  color: ${(props) => props.isUnavailable ? "#9a4b00" : "#0f6b35"};
  background-color: ${(props) => props.isUnavailable ? "rgba(255, 152, 0, 0.14)" : "rgba(29, 145, 74, 0.14)"};
  border: 1px solid ${(props) => props.isUnavailable ? "rgba(255, 152, 0, 0.45)" : "rgba(29, 145, 74, 0.45)"};
  font-size: 10px;
  font-weight: 600;
  line-height: 1.25;
`;

const ItemDisplay = styled.div`
  flex-shrink: 0;
  width: ${props => props.cardLayout ? "100%" : "64px"};
  height: ${props => props.cardLayout ? "auto" : "64px"};
  aspect-ratio: ${props => props.cardLayout ? "4 / 3" : "1"};
 
  border-radius: 6px;
  //Image based on image url in item given
  background-image: url(${(props) => props.shouldHide ? "" : props["data-bg"]});
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  overflow: hidden;
`;

const ItemQtyTxt = styled.div`
  font-size: ${props => props.enlarge ? 20 : 16}px;
  width: ${props => props.enlarge ? 40 : 32}px;
  height: ${props => props.enlarge ? 40 : 32}px;
  color: white;
  display:flex;
  justify-content: center;
  align-items: center;
`;
const ItemQtyIcon = styled.div`
  width: ${props => props.enlarge ? 40 : 32}px;
  height: ${props => props.enlarge ? 40 : 32}px;
  border-radius: ${props => props.enlarge ? 20 : 16}px; 
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(255,255,255,0.6);
  color: black;
  font-size: 16px;
  font-weight:600;
`;
const ItemQtyWrapper = styled.div`
  display:flex;
  padding: ${(props) => props.size == 1 ? "16px  16px" : "8px 4px"};
  border-radius: 6px;
  background-color: rgba(0,0,0,0.6);
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
`;

const IconHolder = ({ icons, enlarge }) => {
  const userContext = React.useContext(UserContext);
  return (

    <IconsContainer enlarge={enlarge}>
      {Array.isArray(icons) && icons.map((iconsLink, index) => (
        <Icons
          enlarge={enlarge}
          key={index + iconsLink + "Icons"}
          iconsLink={iconsLink}
          iconsImg={userContext.icons}
        />
      ))}
    </IconsContainer>
  );
};

const Icons = styled.div`
  height: ${props => props.enlarge ? 30 : 24}px;
  width: ${props => props.enlarge ? 30 : 24}px;
  background-image: url(${(props) => props.iconsImg[props.iconsLink]});
  background-size: ${props => props.enlarge ? 30 : 24}px;
`;

const IconsContainer = styled.div`
  margin-left: 8px;
  display: flex;
  font-size: ${props => props.enlarge ? 24 : 20}px;
  min-width: ${props => props.enlarge ? 30 : 24}px;
  height: ${props => props.enlarge ? 30 : 24}px;
`;
